import { Popover, PopoverProps } from '@mui/material'

export const Menu = ({
  width,
  ...props
}: PopoverProps & { width?: string }) => {
  return (
    <Popover
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      {...props}
      PaperProps={{
        ...props.PaperProps,
        sx: {
          width,
          minWidth: '172px',
          boxShadow:
            '0px 0px 2px rgba(0, 0, 0, 0.2), 0px 2px 10px rgba(0, 0, 0, 0.1)',
          ...props.PaperProps?.sx,
        },
      }}
    />
  )
}
